(function (ws) {
    'use strict';
    ws.views.mandatoryAttachProductsOverlayCartPage = ws.views.modalRequiredProducts.extend({
        /**
         * Events
         */
        events: _.extend({}, ws.views.modalRequiredProducts.prototype.events, {

        }),

        /**
         * Initialize
         */
        initialize: function () {
            ws.views.modalRequiredProducts.prototype.initialize.call(this);
            this.isCart = true;
            this.model = new ws.models.addMandatoryProductsCart();
        }
    });
})(westcon);
